export default __webpack_public_path__ + "images/223efe15eed29108cb849510cf63b1a9-los_angeles_mobile.webp";